import type { OpenAiAdsContext } from '@/shared/lib/openAiAdsContext';

import { getOpenAiAdsContext, OPENAI_ADS_CONSENT_EVENTS } from '@/shared/lib/openAiAdsContext';

import { BASE_URL } from './constants';
import { post, put } from './requestMethods';

const URL = `${BASE_URL}/api/user/openai-ads`;

type OpenAiAdsActivity = {
  contents?: { id: string; content_type: 'product' | 'project'; quantity?: number }[];
  context: OpenAiAdsContext;
  event_id: string;
  event_name: 'checkout_started' | 'contents_viewed';
  price_id?: string;
  quantity?: number;
};

export const OPENAI_ADS_API = {
  sendActivity: async (data: OpenAiAdsActivity) => {
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 500);
    const cancelWithoutConsent = () => {
      if (!getOpenAiAdsContext()?.marketing_consent) controller.abort();
    };
    OPENAI_ADS_CONSENT_EVENTS.forEach((name) => window.addEventListener(name, cancelWithoutConsent));
    try {
      await post<void>(`${URL}/activity`, { data, signal: controller.signal });
    } finally {
      window.clearTimeout(timeout);
      OPENAI_ADS_CONSENT_EVENTS.forEach((name) => window.removeEventListener(name, cancelWithoutConsent));
    }
  },
  saveContext: (data: OpenAiAdsContext, signal?: AbortSignal) => put<void>(URL, { data, signal }),
};
